import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app.module';
import { APP_CONFIG } from '../environment';

if (APP_CONFIG.branding.css) {
    document.getElementsByTagName('body')[0].className = APP_CONFIG.branding.css + ' branded';
}

platformBrowserDynamic().bootstrapModule(AppModule);


// WEBPACK FOOTER //
// ./src/app/main.ts